import { wait } from '@insurgrid/common';

export async function downloadAllLinks(links: string[]) {
  for (const link of links) {
    const anchor = document.createElement('a');
    anchor.href = link;
    anchor.target = '_parent';
    if (anchor.download) {
      anchor.download = link;
    }
    if (anchor.click) {
      anchor.click();
    }
    await wait(500);
  }
}

export const InputDefaultClassName =
  'transition-all py-3 focus:ring-blue focus:border-blue-light transition-colors block w-full sm:text-sm';
